import React, { Component } from 'react'
import './Character.css'

export default class Character extends Component {
    render() {
        return (
            <div>
                <div className='character'><img className='CharacterImg' alt={this.props.char} src={'./pictures/' + this.props.char + '.jpg'}/></div>
            </div>
        )
    }
}
